/**
 * @generated SignedSource<<f99af1ed9670154db32d25fc13c32185>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFormattedDate$data = {
  readonly isoString: string;
  readonly " $fragmentType": "useFormattedDate";
};
export type useFormattedDate$key = {
  readonly " $data"?: useFormattedDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFormattedDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFormattedDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isoString",
      "storageKey": null
    }
  ],
  "type": "Date",
  "abstractKey": "__isDate"
};

(node as any).hash = "8136ff28ff98e95af457851eb5b5ac0e";

export default node;
